import React from 'react';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import o_000 from '../images/wedding_photos/original/000.jpg';
import o_001_1 from '../images/wedding_photos/original/001-1.jpg';
import o_001 from '../images/wedding_photos/original/001.jpg';
import o_01 from '../images/wedding_photos/original/01.jpg';
import o_02 from '../images/wedding_photos/original/02.jpg';
import o_03 from '../images/wedding_photos/original/03.jpg';
import o_04 from '../images/wedding_photos/original/04.jpg';
import o_05 from '../images/wedding_photos/original/05.jpg';
import o_06 from '../images/wedding_photos/original/06.jpg';
import o_07 from '../images/wedding_photos/original/07.jpg';
import o_08 from '../images/wedding_photos/original/08.jpg';
import o_09 from '../images/wedding_photos/original/09.jpg';
import o_10 from '../images/wedding_photos/original/10.jpg';
import o_11 from '../images/wedding_photos/original/11.jpg';
import o_12 from '../images/wedding_photos/original/12.jpg';
import o_13 from '../images/wedding_photos/original/13.jpg';
import o_14 from '../images/wedding_photos/original/14.jpg';
import o_15 from '../images/wedding_photos/original/15.jpg';
import o_16 from '../images/wedding_photos/original/16.jpg';
import o_17 from '../images/wedding_photos/original/17.jpg';
import o_18 from '../images/wedding_photos/original/18.jpg';
import o_19 from '../images/wedding_photos/original/19.jpg';
import o_20 from '../images/wedding_photos/original/20.jpg';
import o_21 from '../images/wedding_photos/original/21.jpg';
import o_22 from '../images/wedding_photos/original/22.jpg';
import o_23 from '../images/wedding_photos/original/23.jpg';
import o_24 from '../images/wedding_photos/original/24.jpg';

import s_000 from '../images/wedding_photos/snapshot/000.jpg';
import s_001_1 from '../images/wedding_photos/snapshot/001-1.jpg';
import s_001 from '../images/wedding_photos/snapshot/001.jpg';
import s_01 from '../images/wedding_photos/snapshot/01.jpg';
import s_02 from '../images/wedding_photos/snapshot/02.jpg';
import s_03 from '../images/wedding_photos/snapshot/03.jpg';
import s_04 from '../images/wedding_photos/snapshot/04.jpg';
import s_05 from '../images/wedding_photos/snapshot/05.jpg';
import s_06 from '../images/wedding_photos/snapshot/06.jpg';
import s_07 from '../images/wedding_photos/snapshot/07.jpg';
import s_08 from '../images/wedding_photos/snapshot/08.jpg';
import s_09 from '../images/wedding_photos/snapshot/09.jpg';
import s_10 from '../images/wedding_photos/snapshot/10.jpg';
import s_11 from '../images/wedding_photos/snapshot/11.jpg';
import s_12 from '../images/wedding_photos/snapshot/12.jpg';
import s_13 from '../images/wedding_photos/snapshot/13.jpg';
import s_14 from '../images/wedding_photos/snapshot/14.jpg';
import s_15 from '../images/wedding_photos/snapshot/15.jpg';
import s_16 from '../images/wedding_photos/snapshot/16.jpg';
import s_17 from '../images/wedding_photos/snapshot/17.jpg';
import s_18 from '../images/wedding_photos/snapshot/18.jpg';
import s_19 from '../images/wedding_photos/snapshot/19.jpg';
import s_20 from '../images/wedding_photos/snapshot/20.jpg';
import s_21 from '../images/wedding_photos/snapshot/21.jpg';
import s_22 from '../images/wedding_photos/snapshot/22.jpg';
import s_23 from '../images/wedding_photos/snapshot/23.jpg';
import s_24 from '../images/wedding_photos/snapshot/24.jpg';


function ImgGallery() {

  const images = [
    {original: o_000, thumbnail: s_000,},
    {original: o_001_1, thumbnail: s_001_1,},
    {original: o_001, thumbnail: s_001,},
    {original: o_01, thumbnail: s_01,},
    {original: o_02, thumbnail: s_02,},
    {original: o_03, thumbnail: s_03,},
    {original: o_04, thumbnail: s_04,},
    {original: o_05, thumbnail: s_05,},
    {original: o_06, thumbnail: s_06,},
    {original: o_07, thumbnail: s_07,},
    {original: o_08, thumbnail: s_08,},
    {original: o_09, thumbnail: s_09,},
    {original: o_10, thumbnail: s_10,},
    {original: o_11, thumbnail: s_11,},
    {original: o_12, thumbnail: s_12,},
    {original: o_13, thumbnail: s_13,},
    {original: o_14, thumbnail: s_14,},
    {original: o_15, thumbnail: s_15,},
    {original: o_16, thumbnail: s_16,},
    {original: o_17, thumbnail: s_17,},
    {original: o_18, thumbnail: s_18,},
    {original: o_19, thumbnail: s_19,},
    {original: o_20, thumbnail: s_20,},
    {original: o_21, thumbnail: s_21,},
    {original: o_22, thumbnail: s_22,},
    {original: o_23, thumbnail: s_23,},
    {original: o_24, thumbnail: s_24,},
  ];

  return (
    <div className='bc-pink container'>
      <ImageGallery items={images} />
    </div>
  )
}

export default ImgGallery